import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const PaymentContext = createContext();

export const usePayment = () => {
    return useContext(PaymentContext);
};

export const PaymentProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const createPayment = async (paymentData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post('/api/payment/create', paymentData);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Ödeme işlemi başarısız oldu');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const checkPaymentStatus = async (paymentId) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`/api/payment/status/${paymentId}`);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || 'Ödeme durumu kontrol edilemedi');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const value = {
        loading,
        error,
        createPayment,
        checkPaymentStatus
    };

    return (
        <PaymentContext.Provider value={value}>
            {children}
        </PaymentContext.Provider>
    );
};

export default PaymentContext; 